export const clientId = '2'
// clientSecret removed - should only be stored server-side
export const companyName = 'Callistech'
